module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-2-Landing-Page-w960.a0e7f4b7.jpg";